import apiClient from './config'

var OLD_PHOTO_REPAIR_PATH = '/repairOldPhoto'
var BLURRY_PHOTO_REPAIR_PATH = '/repairBlurryPhoto'
var CARTOON_DIGITAL_HUMAN_PATH = '/cartoonDigitalHuman'
var MANGA_DIGITAL_HUMAN_PATH = '/mangaDigitalHuman'
var OIL_PAINTING_DIGITAL_HUMAN_PATH = '/oilPaintingDigitalHuman'
var ID_PHOTO_GENERATOR_PATH = '/idPhotoGenerator'
var AI_CHANGE_CLOTHES_PATH = '/aiChangeClothes'
var FULL_WATERMARK_REMOVER_PATH = '/removeImageWatermark'
var AI_TEXT_REMOVER_PATH = '/removeImageText'
var AI_LOGO_REMOVER_PATH = '/removeImageLogo'
var AI_PASSERSBY_REMOVER_PATH = '/removePassersby'
var QUERY_PATH = '/queryQwenResult'
var POLL_INTERVAL = 10000
var POLL_TIMEOUT = 5 * 60 * 1000

function normalizeResultUrl(url) {
  var s = String(url || '').trim()
  if (!s) return ''
  if (/^https?:\/\//i.test(s) || s.indexOf('data:') === 0) return s
  if (s.charAt(0) !== '/') return s
  var base = apiClient.defaults && apiClient.defaults.baseURL ? String(apiClient.defaults.baseURL) : ''
  if (!base || base.charAt(0) === '/') return s
  try {
    var u = new URL(base)
    return u.origin + s
  } catch (e) {
    return s
  }
}

function parsePromptId(payload) {
  var data = payload && payload.data ? payload.data : payload
  var promptId = data && (data.prompt_id || data.promptId)
  return promptId ? String(promptId) : ''
}

function submitPhotoRepair(path, imageUrl, label) {
  var url = String(imageUrl || '').trim()
  if (!url) return Promise.reject(new Error('imageUrl is required'))
  return apiClient.post(path, { imageUrl: url }).then(function (payload) {
    var promptId = parsePromptId(payload)
    if (!promptId) return Promise.reject(new Error(label + ' did not return prompt_id'))
    return {
      promptId: promptId,
      seed: payload && payload.data ? payload.data.seed : undefined
    }
  })
}

function submitTwoImagePhotoRepair(path, imageUrl, image2Url, label) {
  var url = String(imageUrl || '').trim()
  var url2 = String(image2Url || '').trim()
  if (!url) return Promise.reject(new Error('imageUrl is required'))
  if (!url2) return Promise.reject(new Error('image2Url is required'))
  return apiClient.post(path, { imageUrl: url, image2Url: url2 }).then(function (payload) {
    var promptId = parsePromptId(payload)
    if (!promptId) return Promise.reject(new Error(label + ' did not return prompt_id'))
    return {
      promptId: promptId,
      seed: payload && payload.data ? payload.data.seed : undefined
    }
  })
}

export function submitOldPhotoRepair(imageUrl) {
  return submitPhotoRepair(OLD_PHOTO_REPAIR_PATH, imageUrl, 'repairOldPhoto')
}

export function submitBlurryPhotoRepair(imageUrl) {
  return submitPhotoRepair(BLURRY_PHOTO_REPAIR_PATH, imageUrl, 'repairBlurryPhoto')
}

export function submitCartoonDigitalHuman(imageUrl) {
  return submitPhotoRepair(CARTOON_DIGITAL_HUMAN_PATH, imageUrl, 'cartoonDigitalHuman')
}

export function submitMangaDigitalHuman(imageUrl) {
  return submitPhotoRepair(MANGA_DIGITAL_HUMAN_PATH, imageUrl, 'mangaDigitalHuman')
}

export function submitOilPaintingDigitalHuman(imageUrl) {
  return submitPhotoRepair(OIL_PAINTING_DIGITAL_HUMAN_PATH, imageUrl, 'oilPaintingDigitalHuman')
}

export function submitIdPhotoGenerator(imageUrl) {
  return submitPhotoRepair(ID_PHOTO_GENERATOR_PATH, imageUrl, 'idPhotoGenerator')
}

export function submitAiChangeClothes(imageUrl, image2Url) {
  return submitTwoImagePhotoRepair(AI_CHANGE_CLOTHES_PATH, imageUrl, image2Url, 'aiChangeClothes')
}

export function submitFullWatermarkRemover(imageUrl) {
  return submitPhotoRepair(FULL_WATERMARK_REMOVER_PATH, imageUrl, 'removeImageWatermark')
}

export function submitAiTextRemover(imageUrl) {
  return submitPhotoRepair(AI_TEXT_REMOVER_PATH, imageUrl, 'removeImageText')
}

export function submitAiLogoRemover(imageUrl) {
  return submitPhotoRepair(AI_LOGO_REMOVER_PATH, imageUrl, 'removeImageLogo')
}

export function submitAiPassersbyRemover(imageUrl) {
  return submitPhotoRepair(AI_PASSERSBY_REMOVER_PATH, imageUrl, 'removePassersby')
}

export function queryOldPhotoRepairResult(promptId) {
  var id = String(promptId || '').trim()
  if (!id) return Promise.reject(new Error('promptId is required'))
  return apiClient.post(QUERY_PATH, null, {
    params: { promptId: id },
    allowBizCodes: [202]
  }).then(function (payload) {
    var code = Number(payload && payload.code)
    if (code === 202) {
      return { status: 'processing', promptId: id }
    }
    var data = payload && payload.data ? payload.data : {}
    var resultUrl = data.oss_image_url || data.image_url || ''
    resultUrl = normalizeResultUrl(resultUrl)
    if (!resultUrl) return Promise.reject(new Error('No result image was returned'))
    return {
      status: 'completed',
      promptId: data.prompt_id || id,
      url: resultUrl,
      localPath: data.image_local_path || ''
    }
  })
}

export function pollOldPhotoRepairResult(promptId, callback, interval) {
  var pollInterval = interval || POLL_INTERVAL
  var deadline = Date.now() + POLL_TIMEOUT
  var timer = null
  var stopped = false

  function stop() {
    stopped = true
    if (timer) {
      clearTimeout(timer)
      timer = null
    }
  }

  function scheduleNext() {
    if (stopped) return
    if (Date.now() > deadline) {
      if (typeof callback === 'function') callback(new Error('Polling timeout'), null)
      stop()
      return
    }
    timer = setTimeout(poll, pollInterval)
  }

  function poll() {
    if (stopped) return
    queryOldPhotoRepairResult(promptId).then(function (res) {
      if (stopped) return
      if (res.status === 'processing') {
        if (typeof callback === 'function') callback(null, res)
        scheduleNext()
        return
      }
      if (typeof callback === 'function') callback(null, res)
      stop()
    }).catch(function (err) {
      if (typeof callback === 'function') callback(err, null)
      stop()
    })
  }

  poll()
  return { stop: stop }
}

export default {
  submitOldPhotoRepair: submitOldPhotoRepair,
  submitBlurryPhotoRepair: submitBlurryPhotoRepair,
  submitCartoonDigitalHuman: submitCartoonDigitalHuman,
  submitMangaDigitalHuman: submitMangaDigitalHuman,
  submitOilPaintingDigitalHuman: submitOilPaintingDigitalHuman,
  submitIdPhotoGenerator: submitIdPhotoGenerator,
  submitAiChangeClothes: submitAiChangeClothes,
  submitFullWatermarkRemover: submitFullWatermarkRemover,
  submitAiTextRemover: submitAiTextRemover,
  submitAiLogoRemover: submitAiLogoRemover,
  submitAiPassersbyRemover: submitAiPassersbyRemover,
  queryOldPhotoRepairResult: queryOldPhotoRepairResult,
  pollOldPhotoRepairResult: pollOldPhotoRepairResult
}
